module.exports = __webpack_public_path__ + "static/product-pa200-olive-drab-d355163fec2c01eac5816fab32530bfc.png";